import { OnInit, OnChanges, SimpleChanges, EventEmitter, ElementRef, OnDestroy, AfterViewInit, Renderer2 } from '@angular/core';
import { Globals } from '../objects/Globals';
import { Router } from '@angular/router';
import { DetailService } from '../services/detail.service';
import { ConfirmationService } from '../services/confirmation.service';
import { Action } from '../objects/DetailObject';
import { ToasterMessageService } from '../services/toaster-message.service';
import { DetailPopupComponent } from '../detail-popup/detail-popup.component';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgForm } from '@angular/forms';
import { ThemeSettingService } from '../services/theme-setting.service';
import { of, Observable, BehaviorSubject, Subject } from 'rxjs';
import { WorkspaceService } from '../services/workspace.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material';
import { HeaderService } from '../services/header.service';
import { EnvService } from '../env.service';
import { AttachmentService } from '../services/attachment.service';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { MessagePopupService } from '../services/message-popup.service';
import { debounceTime } from 'rxjs/operators';
import { SessionTimerService } from '../services/session-timer.service';
import { FloatingPanelService } from '../services/floating-panel.service';
import { SidePopupService } from '../services/side-popup.service';
var DetailComponent = /** @class */ (function () {
    function DetailComponent(globals, detailService, attachmentService, confirmationService, router, modalService, sanitizer, toasterMessageService, workflowReturnService, themeSettingService, workspaceService, contextMenuService, headerService, env, render, messagePopupService, sessionTimerService, eRef, floatingPanelService, sidePopupService) {
        var _this = this;
        this.globals = globals;
        this.detailService = detailService;
        this.attachmentService = attachmentService;
        this.confirmationService = confirmationService;
        this.router = router;
        this.modalService = modalService;
        this.sanitizer = sanitizer;
        this.toasterMessageService = toasterMessageService;
        this.workflowReturnService = workflowReturnService;
        this.themeSettingService = themeSettingService;
        this.workspaceService = workspaceService;
        this.contextMenuService = contextMenuService;
        this.headerService = headerService;
        this.env = env;
        this.render = render;
        this.messagePopupService = messagePopupService;
        this.sessionTimerService = sessionTimerService;
        this.eRef = eRef;
        this.floatingPanelService = floatingPanelService;
        this.sidePopupService = sidePopupService;
        this.loadingPreview = new BehaviorSubject(false);
        this.next = new Subject();
        this.showEmpty = false;
        this.isSubDetail = false;
        this.isPreview = false;
        this.isPopupDetail = false;
        this.autoRefresh = false;
        this.displayDetail = true;
        this.fromBroadcast = false;
        this.hideSection = false;
        this.selectedSubItemId = new EventEmitter();
        this.selectedSubItemType = new EventEmitter();
        this.updateAll = new EventEmitter();
        this.docId = new EventEmitter();
        this.refreshPopup = new EventEmitter();
        this.hidePopup = new EventEmitter();
        this.title = new EventEmitter();
        this.loadingPopup = new EventEmitter();
        this.subSelectedId = new EventEmitter();
        this.subForm = new EventEmitter();
        this.detailActions = new EventEmitter();
        this.propertyValueChanged = new EventEmitter();
        this.emitProperty = new EventEmitter();
        this.hideCheckbox = true;
        this.animate = true;
        this.isBusy = false;
        this.submitted = false;
        this.hiddenProperties = [];
        this.fixedMessageList = new Object();
        this.sectionStatus = new Object();
        this.animation = false;
        this.sections = [];
        this.groups = [];
        this.actions = [];
        this.checkSummaryUpdate = false;
        this.updateChild = false;
        this.subForms = {};
        this.isSticky = false;
        this.lookupArray = [];
        this.hiddenList = [];
        this.actionsReady = false;
        this.loadingNextPreview = false;
        this.lastPreview = false;
        this.hideDetailHeader = false;
        this.nextPreview = false;
        this.hasGroupLoading = false;
        this.showBtnMore = false;
        this.showHidden = false;
        this.noLoading = false;
        this.treeNodes = [];
        this.hasChildren = function (_, node) {
            // return node.children && node.children.length > 0;
            return node.hasChild;
        };
        this.loadMore = function (_, node) {
            return node;
        };
        this.isDebug = this.env.enableDebug;
        this.sub1 = this.workspaceService.currentParentIdChanged$.subscribe(function (id) {
            if (_this.componentId == id) {
                _this.isBusy = true;
                _this.getDetailCard();
            }
        });
        this.sub2 = this.detailService.treeDataChanged.subscribe(function (result) {
            if (result) {
                var index = _this.lookupArray.indexOf(function (x) { return x.name == result.name; });
                if (index < 0) {
                    _this.lookupArray.push(result);
                }
                else {
                    _this.lookupArray[index] = result;
                }
            }
        });
        this.sub3 = this.detailService.loadMoreChanged.subscribe(function (result) {
            if (_this.lookupArray.length > 0) {
                var currentLookup = _this.lookupArray.find(function (x) { return x.name == result.name; });
                if (currentLookup) {
                    var index = _this.lookupArray.findIndex(function (x) { return x.name == result.name; });
                    if (index > -1) {
                        _this.constructHierarchy(_this.detailProperties.find(function (x) { return x.PropertyName == result.name; }), currentLookup.data.slice(0, (result.page * 100)));
                    }
                }
            }
        });
        this.sub4 = this.workflowReturnService.isLoadingHomeChanged.subscribe(function (result) {
            if (result) {
                _this.isBusy = true;
            }
            else {
                _this.isBusy = false;
            }
        });
        // this.treeControl = new NestedTreeControl<MyTreeNode>(this.makeGetChildrenFunction());
        // this.treeDataSource = new MatTreeNestedDataSource();
        // this.treeDataSource.data = this.treeNodes;
    }
    DetailComponent.prototype.clickout = function (event) {
        if (this.hiddenActions && this.btnShowMore) {
            if (this.hiddenActions.nativeElement.contains(event.target) || this.btnShowMore.first.nativeElement.contains(event.target)) {
            }
            else {
                this.showHidden = false;
            }
        }
    };
    DetailComponent.prototype.onScroll = function (event) {
        // if (this.isPopupDetail){
        this.scrollEvent = event;
        if (this.detailProperties) {
            this.detailProperties.forEach(function (element) {
                element.IsDropdownOpen = false;
            });
        }
        if (this.combinationProperty) {
            this.combinationProperty.forEach(function (list) {
                list.properties.forEach(function (prop) {
                    prop.IsDropdownOpen = false;
                });
            });
        }
        // }
    };
    Object.defineProperty(DetailComponent.prototype, "setComponentId", {
        set: function (id) {
            if (id) {
                this.showEmpty = false;
                if (id == 1) {
                    this.animate = true;
                    this.isBusy = false;
                }
                else {
                    this.errorMessage = "";
                    this.componentId = id;
                    this.isBusy = true;
                    if (this.sub)
                        this.sub.unsubscribe();
                    this.getDetailCard();
                }
            }
            else if (id == 0) {
                this.animate = false;
                this.isBusy = true;
                this.showEmpty = false;
            }
            else {
                this.showEmpty = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailComponent.prototype, "forceRefresh", {
        set: function (isTrue) {
            if (this.globals.Session) {
                this.getDetailCard();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailComponent.prototype, "setSubDetail", {
        set: function (obj) {
            var _this = this;
            if (!this.autoRefresh)
                this.isBusy = true;
            this.detailService.getNewDetailFromPropertyGroup(obj.DetailId, obj.PropertyGroupId).subscribe(function (id) {
                if (id) {
                    _this.componentId = id;
                    _this.getDetailCard();
                }
                else {
                    _this.isBusy = false;
                }
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailComponent.prototype, "actionOnDetail", {
        set: function (action) {
            if (action) {
                this.onDetailAction(action, this.detailForm, true);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailComponent.prototype, "parentScroll", {
        set: function (scrollEvent) {
            if (scrollEvent) {
                this.onScroll(scrollEvent);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DetailComponent.prototype, "triggerFocus", {
        set: function (focus) {
            if (this.detailObject) {
                var properties = this.sortPropertiesByGroup();
                for (var i in properties) {
                    if (this.detailForm.control.get(properties[i].PropertyName)) {
                        if (this.detailForm.control.get(properties[i].PropertyName).invalid) {
                            if (this.detailObject.Groups.filter(function (x) { return x.GroupId == properties[i].PropertyGroupId; }).length > 0) {
                                this.detailObject.Groups.find(function (x) { return x.GroupId == properties[i].PropertyGroupId; }).IsExpanded = true;
                                this.hiddenPropertyFocus = properties[i];
                            }
                            else {
                                this.hiddenPropertyFocus = null;
                                this.detailService.setPropertyFocus(properties[i].PropertyId);
                            }
                            break;
                        }
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    DetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        var themes = this.themeSettingService.getTheme();
        this.loaderConfig = themes;
        if (this.documentId) {
            this.getDetailCard();
        }
        this.next.pipe(debounceTime(100)).subscribe(function (result) {
            if (!_this.loadingNextPreview && !_this.lastPreview) {
                _this.nextPreview = true;
                _this.getPreviewNextSection(event);
            }
        });
    };
    DetailComponent.prototype.ngOnDestroy = function () {
        if (this.sub)
            this.sub.unsubscribe();
        if (this.sub1)
            this.sub1.unsubscribe();
        if (this.sub2)
            this.sub2.unsubscribe();
        if (this.sub3)
            this.sub3.unsubscribe();
        if (this.sub4)
            this.sub4.unsubscribe();
        this.sessionTimerService.setKeepSessionAlive(false);
    };
    DetailComponent.prototype.makeGetChildrenFunction = function () {
        return function (node) { return of(node.children); };
    };
    DetailComponent.prototype.checkIfHasError = function (id) {
        var noError = true;
        if (id) {
            if (id.startsWith("ERROR:")) {
                noError = false;
                this.componentId = "";
                this.errorMessage = id.substr(6, id.length - 1);
                this.isBusy = false;
            }
            else {
                noError = true;
            }
        }
        else {
            noError = false;
            this.isBusy = false;
        }
        return noError;
    };
    DetailComponent.prototype.getDetailCard = function () {
        var _this = this;
        if (this.checkIfHasError(this.componentId)) {
            if (this.componentId) {
                this.detailService.getCurrentSection(this.componentId).subscribe(function (section) {
                    _this.selectedSection = section;
                });
                this.detailService.getDetail(this.componentId).subscribe(function (cardResult) {
                    _this.detailObject = JSON.parse(cardResult);
                    // console.log(JSON.parse(cardResult));
                    _this.propertyUpdate = null;
                    _this.title.emit(_this.detailObject.DocTitle);
                    _this.detailService.isNewDetail(true);
                    _this.submitted = false;
                    _this.combinationProperty = [];
                    _this.hiddenList = [];
                    if (_this.detailObject) {
                        _this.detailProperties = _this.detailObject.Properties.filter(function (x) { return x.PropertyOrder != 0; }).filter(function (x) { return !x.PropertyIsHidden; });
                        _this.hiddenProperties = _this.detailObject.Properties.filter(function (x) { return x.PropertyOrder == 0; });
                        _this.sortProperties();
                        _this.sortPropertySections();
                        _this.sortDetailActions();
                        _this.formatPropertyGroups();
                        _this.handleDetailHeader();
                        _this.sectionStatus = {};
                        _this.currentHierarchyId = null;
                        _this.detailActions.emit(_this.actions);
                        _this.detailObject.Sections.forEach(function (element) {
                            if (element.ValidationStatus == "-1") {
                                _this.detailService.getSectionStatus(_this.componentId, element.SectionId).subscribe(function (result) {
                                    if (result) {
                                        _this.sectionStatus[element.SectionId] = result;
                                    }
                                });
                            }
                            else {
                                _this.sectionStatus[element.SectionId] = element.ValidationStatus;
                            }
                        });
                        if (_this.detailObject.Properties.filter(function (x) { return x.PropertyFormControlType.toUpperCase() == "EMIT"; }).length > 0) {
                            _this.emitProperty.emit(_this.detailObject.Properties.find(function (x) { return x.PropertyFormControlType.toUpperCase() == "EMIT"; }).PropertyValue);
                        }
                        else if (_this.detailObject.Properties.filter(function (x) { return x.PropertyFormControlType.toUpperCase() == "KEEPSESSIONALIVE"; }).length > 0) {
                            _this.handleSessionProperty(_this.detailObject.Properties.find(function (x) { return x.PropertyFormControlType.toUpperCase() == "KEEPSESSIONALIVE"; }));
                        }
                        _this.formatProperties();
                        if (_this.detailObject.StateDisplayType == "ProcessingDetail" || _this.detailObject.StateDisplayType == "ProcessingSectionDetail") {
                            _this.checkDetailUpdate();
                        }
                        else if (_this.detailObject.StateDisplayType == "ProcessingActionLeft" || _this.detailObject.StateDisplayType == "ProcessingSimple") {
                            _this.checkDetailUpdate();
                            _this.detailObject.DocTitle = "";
                            _this.detailObject.DocSubtitle = "";
                        }
                        else if (_this.detailObject.StateDisplayType == "Simple") {
                            _this.detailObject.DocTitle = "";
                            _this.detailObject.DocSubtitle = "";
                        }
                        else {
                            if (_this.sub)
                                _this.sub.unsubscribe();
                        }
                        _this.detailObject.IsAutoLoad = _this.noLoading;
                        _this.previousComponentId = _this.componentId;
                        _this.stateDisplayType = _this.detailObject.StateDisplayType;
                        _this.isBusy = false;
                        _this.loadingPopup.emit(false);
                        _this.animate = true;
                        _this.noLoading = false;
                        //this.scrollToTop();
                    }
                }, function (error) {
                    _this.isBusy = false;
                    _this.noLoading = false;
                    if (_this.sub)
                        _this.sub.unsubscribe();
                });
            }
            else {
                this.animate = true;
                this.isBusy = false;
            }
        }
    };
    DetailComponent.prototype.handleDetailHeader = function () {
        if ((this.actions.length == 0 && !this.detailObject.DocTitle && !this.detailObject.DocSubtitle)
            || this.detailObject.StateDisplayType == "ActionBottom" || this.detailObject.StateDisplayType == "ProcessingSimple"
            || this.detailObject.StateDisplayType == "Simple" || this.isPopupDetail) {
            this.hideDetailHeader = true;
        }
        else {
            this.hideDetailHeader = false;
        }
    };
    DetailComponent.prototype.formatProperties = function (isTempProperties) {
        var _this = this;
        if (isTempProperties === void 0) { isTempProperties = false; }
        var detailProperties = this.detailProperties;
        if (isTempProperties)
            detailProperties = this.tempDetailProperties;
        detailProperties.forEach(function (element) {
            if (element.PropertyFormControlType.toUpperCase() == "MULTITEXT") {
                if (element.PropertyValueArray) {
                    var a_1 = [];
                    element.PropertyValueArray.forEach(function (value) {
                        var b = { SelectionValue: value, SelectionDisplay: value, SelectionMapValue: value, GroupBy: null, IsSelected: false, HasChild: false };
                        a_1.push(b);
                    });
                    element.PropertyValueSelection = a_1;
                    _this.getLookupList(element);
                }
            }
            else if (element.PropertyFormControlType.toUpperCase() == "FIXEDMESSAGE") {
                _this.getFixedMessage(element.PropertyId);
            }
            else if (element.PropertyFormControlType.toUpperCase() == "COMBINATION") {
                _this.constructCombinationProperty(element);
            }
            else if (element.PropertyFormControlType.toUpperCase() == 'FIXEDFILE') {
                _this.downloadFixedFile(element);
            }
            else if (element.PropertyFormControlType.toUpperCase() == "PDFVIEWER") {
                _this.downloadPdfFile(element);
            }
            else if (element.PropertyFormControlType.toUpperCase() == "COUNTDOWN") {
                _this.handleCountdownProperty(element);
            }
            else if (element.PropertyFormControlType.toUpperCase() == "HIERARCHYSINGLESELECT") {
                element.PropertyValueArray = [];
                if (element.PropertyValue) {
                    element.PropertyValueArray = [element.PropertyValue];
                }
                _this.getHierarchy(element);
            }
            else if (element.PropertyFormControlType.toUpperCase() == "HIERARCHYMULTISELECT") {
                _this.getHierarchy(element);
            }
            else if (element.PropertyFormControlType.toUpperCase() == "MULTICOMBOBOX") {
                _this.getLookupList(element);
            }
            else if (element.PropertyFormControlType.toUpperCase() == "DATE" || element.PropertyFormControlType.toUpperCase() == "DATETIME") {
                _this.handleMinMaxDate(element, detailProperties);
            }
            if (element.ParentPropertyName) {
                if (_this.detailProperties.find(function (x) { return x.PropertyName == element.ParentPropertyName; })) {
                    if (_this.detailProperties.find(function (x) { return x.PropertyName == element.ParentPropertyName; }).PropertyFormControlType.toUpperCase() == "OPTIONALMULTIPLEFILES"
                        || _this.detailProperties.find(function (x) { return x.PropertyName == element.ParentPropertyName; }).PropertyFormControlType.toUpperCase() == "OPTIONALFILE") {
                        element.PropertyClientIsHidden = true;
                    }
                    _this.detailProperties.find(function (x) { return x.PropertyName == element.ParentPropertyName; }).ChildPropertyName = element.PropertyName;
                }
            }
        });
    };
    DetailComponent.prototype.handleMinMaxDate = function (element, detailProperties) {
        if (element.PropertyValidation) {
            if (element.PropertyValidation.MinValue) {
                if (element.PropertyValidation.MinValue.indexOf("{") > -1) {
                    var matchProp = detailProperties.find(function (x) { return x.PropertyName == element.PropertyValidation.MinValue.replace("{", "").replace("}", ""); });
                    if (matchProp) {
                        element.PropertyValidation.MinValue = matchProp.PropertyValue;
                    }
                }
            }
            if (element.PropertyValidation.MaxValue) {
                if (element.PropertyValidation.MaxValue.indexOf("{") > -1) {
                }
            }
        }
    };
    DetailComponent.prototype.scrollToTop = function () {
        if ((this.stateDisplayType != 'MultiSectionDetail' && this.stateDisplayType != 'ProcessSectionDetail') || this.isPopupDetail) {
            if (this.subContainer) {
                this.subContainer.nativeElement.scrollTop = 0;
            }
        }
        else {
            if (this.groupContainer)
                this.groupContainer.nativeElement.scrollTop = 0;
        }
    };
    DetailComponent.prototype.checkDetailUpdate = function () {
        var _this = this;
        if (this.sub)
            this.sub.unsubscribe();
        var timer = Observable.timer(1000, this.env.checkIntervalUpdate ? this.env.checkIntervalUpdate * 1000 : 5000);
        this.sub = timer.subscribe(function (t) { return _this.checkIfHasUpdate(); });
    };
    DetailComponent.prototype.formatPropertyGroups = function () {
        var _this = this;
        this.detailObject.Groups.forEach(function (group) {
            // get group actions
            group.GroupActions = [];
            group.GroupActions = _this.detailObject.Actions.filter(function (x) { return x.DisplayOnGroup == group.GroupId; }).filter(function (x) { return !x.IsHidden; });
            if (group.GroupFormat.indexOf('ACCORDION') > -1) {
                if (group.GroupFormat.indexOf('OPEN') > -1) {
                    group.IsExpanded = true;
                }
            }
            group.InitialLoad = true;
        });
        this.sortPropertyGroups();
    };
    DetailComponent.prototype.retrieveCombobox = function (propertyName) {
        this.detailService.getLookupList(this.componentId, propertyName).subscribe(function (result) {
            var lookupList = JSON.parse(result);
            //this.detailObject.Properties.find(x=> x.PropertyName == propertyName).ValuesSelection = lookupList;
            // this.detailObject.Properties.find(x => x.PropertyName == propertyName).ValuesSelection.forEach(element => {
            // element.SelectionValue = element.SelectionValue.toLowerCase();
            // element.SelectionMapValue = element.SelectionValue;
            // console.log(this.detailObject.Properties.find(x=> x.PropertyName == propertyName).ValuesSelection);
            // });
        });
    };
    DetailComponent.prototype.refreshDetail = function (event) {
        this.isBusy = true;
        this.getDetailCard();
    };
    DetailComponent.prototype.updateForm = function (prop) {
        this.detailForm.control.get(prop.ParentPropertyName).setErrors({ noMatch: true });
    };
    DetailComponent.prototype.getPropertyWidth = function (propertyId, order) {
        if (order == 0) {
            return this.combinationProperty.find(function (x) { return x.combinationId == propertyId; }).columnWidth[0].initialColumnWidth;
        }
        else {
            return this.combinationProperty.find(function (x) { return x.combinationId == propertyId; }).columnWidth[0].secColumnWidth;
        }
    };
    DetailComponent.prototype.getDate = function (date, format) {
        if (!format) {
            format = "dd/MM/yyyy";
        }
        if (!date) {
            return date;
        }
        else {
            return new DatePipe("en-US").transform(new Date(date), format);
        }
    };
    DetailComponent.prototype.onSelectedItem = function (selectedId) {
        this.subSelectedId.emit(selectedId);
        if (this.isPopupDetail) {
            this.openPopup(selectedId, "");
        }
    };
    DetailComponent.prototype.onValueChange = function (event) {
        this.propertyValueChanged.emit(event);
        if (this.isPopupDetail) {
            this.openPopup(event, "");
        }
    };
    DetailComponent.prototype.downloadFixedFile = function (property) {
        var _this = this;
        if (property.PropertyDisplayFormat) {
            var fileList = property.PropertyDisplayFormat.split(',');
            property.PropertyFixedFileUrl = [];
            fileList.forEach(function (file) {
                _this.attachmentService.downloadFile(file.split('|')[1]).subscribe(function (data) {
                    property.PropertyFixedFileUrl.push(_this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(data)));
                });
            });
        }
    };
    DetailComponent.prototype.downloadPdfFile = function (property) {
        if (property.PropertyValue) {
            this.attachmentService.downloadFile(property.PropertyValue).subscribe(function (data) {
                property.PropertyFixedFileUrl = [];
                property.PropertyFixedFileUrl.push(data);
            });
        }
    };
    DetailComponent.prototype.handleSessionProperty = function (property) {
        this.sessionTimerService.setKeepSessionAlive(true);
    };
    DetailComponent.prototype.handleCountdownProperty = function (property) {
        if (property.ParentPropertyName) {
            var prop = this.detailObject.Properties.find(function (x) { return x.PropertyName == property.ParentPropertyName; });
            if (prop) {
                property.ParentPropertyValue = prop.PropertyValue;
            }
        }
    };
    DetailComponent.prototype.openPopup = function (event, title, isPreview) {
        var _this = this;
        if (isPreview === void 0) { isPreview = false; }
        var popupClass = "modal-dialog-centered modal-detail";
        if (isPreview)
            popupClass += " modal-preview";
        var config = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: popupClass,
            initialState: {
                componentId: event,
                title: title,
                isPreview: isPreview
            }
        };
        if (this.modalService.getModalsCount() > 0) {
            document.querySelectorAll('.modal.fade').item(this.modalService.getModalsCount() - 1).classList.remove('show');
        }
        this.modalService.onHide.subscribe(function (reason) {
            if (_this.modalService.getModalsCount() > 0) {
                document.querySelectorAll('.modal.fade').item(_this.modalService.getModalsCount() - 1).classList.add('show');
            }
            else {
                _this.isPopupDetail = false;
            }
        });
        this.modalRef = this.modalService.show(DetailPopupComponent, config);
    };
    DetailComponent.prototype.onRefreshAll = function (isUpdate) {
        this.getDetailCard();
        this.updateAll.emit(true);
    };
    DetailComponent.prototype.handleDateTimeProperty = function (form) {
        this.detailProperties.filter(function (x) { return x.PropertyFormControlType.toUpperCase() == 'DATETIME'; }).forEach(function (prop) {
            if (!prop.PropertyValidation && prop.PropertyIsEditable) {
                if (form.controls[prop.PropertyName]) {
                    form.controls[prop.PropertyName].setErrors(null);
                }
            }
            else if (prop.PropertyValidation && prop.PropertyIsEditable) {
                if (prop.PropertyValidation.MinValue == "@CURRENTDATETIME") {
                    var date = new Date();
                    if (prop.PropertyValue) {
                        var value = new Date(prop.PropertyValue);
                        var date = new Date();
                        if (date < value) {
                            // check if only dateMin error is present
                            if (form.controls[prop.PropertyName].errors) {
                                if (form.controls[prop.PropertyName].errors.DateMin || form.controls[prop.PropertyName].errors.matDatepickerMin) {
                                    form.controls[prop.PropertyName].setErrors(null);
                                }
                            }
                        }
                        else if (date > value) {
                            form.controls[prop.PropertyName].markAsDirty();
                            form.controls[prop.PropertyName].setErrors({ DateMin: true });
                        }
                    }
                }
            }
        });
        return form;
    };
    DetailComponent.prototype.onDetailAction = function (action, form, scrollToTop) {
        this.animate = false;
        if (this.detailProperties.filter(function (x) { return x.PropertyFormControlType.toUpperCase() == 'DATETIME'; }).length > 0) {
            form = this.handleDateTimeProperty(form);
        }
        if (action.TriggersSubAction) {
            // SAMPLE :- SubmitProfile|FORM_SAVE
            var formName_1 = action.TriggersSubAction.split('|')[0];
            var actionCommand = action.TriggersSubAction.split('|')[1];
            if (this.subForms[actionCommand]) {
                var status_1 = this.subForms[formName_1];
                if (status_1 == "VALID") {
                    this.runValidation(action, form, scrollToTop);
                }
                else {
                    this.groups.find(function (x) { return x.GroupName == formName_1; }).TriggerFocus = !this.groups.find(function (x) { return x.GroupName == formName_1; }).TriggerFocus;
                }
            }
            else {
                this.runValidation(action, form, scrollToTop);
            }
        }
        else {
            this.runValidation(action, form, scrollToTop);
        }
    };
    DetailComponent.prototype.runValidation = function (action, form, scrollToTop) {
        if (action.TriggersValidation) {
            if (form.valid) {
                // if (scrollToTop){
                //   this.scrollToTop();
                // }
                this.handlePrompt(action);
            }
            else {
                this.submitted = true;
                var properties = this.sortPropertiesByGroup();
                for (var i in properties) {
                    if (form.control.get(properties[i].PropertyName)) {
                        if (form.control.get(properties[i].PropertyName).invalid) {
                            if (this.detailObject.Groups.filter(function (x) { return x.GroupId == properties[i].PropertyGroupId; }).length > 0) {
                                this.detailObject.Groups.find(function (x) { return x.GroupId == properties[i].PropertyGroupId; }).IsExpanded = true;
                            }
                            this.detailService.setPropertyFocus(properties[i].PropertyId);
                            break;
                        }
                    }
                }
            }
        }
        else {
            // if (scrollToTop){
            //   this.scrollToTop();
            // }
            this.handlePrompt(action);
        }
    };
    DetailComponent.prototype.handlePrompt = function (action) {
        var _this = this;
        if (action.TriggersPrompt) {
            switch (action.PromptType) {
                case "Yes|No":
                    this.isBusy = true;
                    this.detailService.checkActionPrompt(this.componentId, action.ActionCommand).subscribe(function (result) {
                        if (result) {
                            _this.handleWorkflowReturn(result);
                        }
                        else {
                            _this.isBusy = false;
                            _this.confirmationService.confirm("Confirmation", action.PromptMessage.split('|')[0], ["CANCEL", "OK"])
                                .subscribe(function (respond) {
                                if (respond.answer == "OK") {
                                    _this.detailAction(action);
                                }
                            });
                        }
                    }, function (error) {
                        _this.isBusy = false;
                    });
                    break;
                case "TypeToConfirm":
                    this.isBusy = true;
                    this.detailService.checkActionPrompt(this.componentId, action.ActionCommand).subscribe(function (result) {
                        if (result) {
                            _this.handleWorkflowReturn(result);
                        }
                        else {
                            _this.isBusy = false;
                            _this.confirmationService.confirm(action.PromptMessage.split('|')[0], "", ["CANCEL", "OK"], true, action.PromptMessage.split('|')[1], false, action.PromptMessage.split('|')[2])
                                .subscribe(function (respond) {
                                if (respond.answer == "OK") {
                                    _this.detailAction(action);
                                }
                            });
                        }
                    }, function (error) {
                        _this.isBusy = false;
                    });
                    break;
                case "OK":
                    this.isBusy = true;
                    this.detailService.checkActionPrompt(this.componentId, action.ActionCommand).subscribe(function (result) {
                        if (result) {
                            _this.handleWorkflowReturn(result);
                        }
                        else {
                            _this.isBusy = false;
                            _this.messagePopupService.popMessage("", action.PromptMessage.split('|')[0], ["OK"]).subscribe(function (respond) {
                                if (respond.answer == "OK") {
                                    _this.detailAction(action);
                                }
                            });
                        }
                    }, function (error) {
                        _this.isBusy = false;
                    });
                    break;
                case "Preview":
                    this.isBusy = true;
                    this.detailService.checkActionPrompt(this.componentId, action.ActionCommand).subscribe(function (result) {
                        if (result) {
                            _this.handleWorkflowReturn(result);
                        }
                        else {
                            _this.detailService.getPreview(_this.componentId, action.ActionCommand).subscribe(function (previewId) {
                                _this.isBusy = false;
                                _this.openPopup(previewId, action.PromptMessage.split('|')[0], true);
                            });
                        }
                    }, function (error) {
                        _this.isBusy = false;
                    });
                    break;
            }
        }
        else {
            this.detailAction(action);
        }
    };
    DetailComponent.prototype.detailAction = function (action) {
        var _this = this;
        this.animate = false;
        if (this.isPopupDetail) {
            this.loadingPopup.emit(true);
        }
        else {
            this.isBusy = true;
        }
        var pendingUpdates = this.detailService.getPendingUpdate();
        if (pendingUpdates.length > 0) {
            var formattedObj = [];
            pendingUpdates.forEach(function (updateObj) {
                formattedObj.push({ name: updateObj.property.PropertyName, value: updateObj.value });
            });
            this.promiseUpdates(formattedObj).then(function (result) {
                _this.detailService.clearPendingUpdate();
                _this.detailService.detailAction(_this.componentId, action.ActionCommand).subscribe(function (result) {
                    _this.handleWorkflowReturn(result);
                }, function (error) {
                    if (_this.isPopupDetail) {
                        _this.loadingPopup.emit(false);
                    }
                    else {
                        _this.isBusy = false;
                    }
                });
            });
        }
        else {
            this.detailService.detailAction(this.componentId, action.ActionCommand).subscribe(function (result) {
                _this.handleWorkflowReturn(result);
            }, function (error) {
                if (_this.isPopupDetail) {
                    _this.loadingPopup.emit(false);
                }
                else {
                    _this.isBusy = false;
                }
            });
        }
    };
    DetailComponent.prototype.promiseUpdates = function (formattedObj) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var returnObj;
            _this.detailService.updateMultiFields(_this.componentId, formattedObj).subscribe(function (results) {
                returnObj = results;
                resolve(returnObj);
            });
        });
    };
    DetailComponent.prototype.handleWorkflowReturn = function (result) {
        var command = JSON.parse(result);
        this.workflowReturnService.handleWorkflowReturn(command);
        if (command.ReturnType != 10 && (command.RefreshType == "self" || command.RefreshType == "none")) {
            this.animate = true;
            if (this.isPopupDetail) {
                this.loadingPopup.emit(false);
            }
            else {
                this.isBusy = false;
            }
        }
        //this.currentSelectedLookup = null;
        switch (command.RefreshType) {
            case "self":
                this.getDetailCard();
                break;
            case "parent":
                this.isBusy = true;
                this.getDetailCard();
                this.getEPICParent(false, command.ReturnType, command.IsPreview);
                break;
            case "all":
                this.getDetailCard();
                this.getEPICParent(true, command.ReturnType, command.IsPreview);
                break;
        }
    };
    DetailComponent.prototype.getEPICParent = function (findAllParent, returnType, isPreview) {
        var _this = this;
        if (isPreview === void 0) { isPreview = false; }
        if (findAllParent) {
            this.workspaceService.getAllParentsEPICId(this.componentId).subscribe(function (result) {
                _this.handlePopup(returnType, isPreview);
                if (result) {
                    var array = JSON.parse(result);
                    array.forEach(function (id) {
                        _this.workspaceService.setParentId(id);
                    });
                }
            }, function (error) {
                _this.handlePopup(returnType, isPreview);
            });
        }
        else {
            this.workspaceService.getParentEPICId(this.componentId).subscribe(function (result) {
                _this.workspaceService.setParentId(result);
                _this.handlePopup(returnType, isPreview);
            }, function (error) {
                _this.handlePopup(returnType, isPreview);
            });
        }
    };
    DetailComponent.prototype.handlePopup = function (returnType, isPreview) {
        if (isPreview === void 0) { isPreview = false; }
        if (returnType == 4 || isPreview) {
            this.hidePopup.emit(true);
            this.animate = true;
            if (this.isPopupDetail) {
                this.loadingPopup.emit(false);
            }
            else {
                this.isBusy = false;
            }
        }
    };
    DetailComponent.prototype.hidesAllModals = function () {
        if (this.confirmationService.bsModalRef) {
            this.confirmationService.bsModalRef.hide();
        }
        for (var i = 1; i <= this.modalService.getModalsCount(); i++) {
            this.modalService.hide(i);
        }
        document.body.classList.remove('modal-open');
        this.sidePopupService.removePopup();
    };
    DetailComponent.prototype.handleNavigateAndMessage = function (command, hasSession) {
        if (hasSession === void 0) { hasSession = false; }
        var path = [];
        var newArgs = command.Arguments.splice(2);
        newArgs.forEach(function (element) {
            path.push(element);
        });
        if (hasSession) {
            // close all popups
            for (var i = 1; i <= this.modalService.getModalsCount(); i++) {
                this.modalService.hide(i);
            }
            document.body.classList.remove("modal-open");
            this.router.navigate(path);
            this.headerService.setSelectedMenu('clearSelected');
            this.toasterMessageService.popToast(command.Arguments[0], command.Arguments[1], command.SubType);
        }
    };
    DetailComponent.prototype.downloadFile = function (blob, fileName) {
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(objectUrl);
    };
    DetailComponent.prototype.showLoading = function ($event, scrollToTop) {
        if ($event) {
            this.animate = false;
            if (this.isPopupDetail) {
                this.loadingPopup.emit(true);
            }
            else {
                this.isBusy = true;
            }
        }
        else {
            if (this.isPopupDetail) {
                this.loadingPopup.emit(false);
            }
            else {
                this.isBusy = false;
            }
        }
        // if (scrollToTop){
        //   this.scrollToTop();
        // }
    };
    DetailComponent.prototype.changeSection = function (sectionId) {
        var _this = this;
        this.isBusy = true;
        this.animate = false;
        this.submitted = false;
        this.detailService.changeSection(this.componentId, sectionId).subscribe(function (result) {
            if (result == "1") {
                _this.getDetailCard();
            }
        });
    };
    DetailComponent.prototype.getFixedMessage = function (propertyId) {
        var _this = this;
        this.detailService.getFixedMessageText(this.componentId, propertyId).subscribe(function (result) {
            _this.fixedMessageList[propertyId] = result;
        });
    };
    DetailComponent.prototype.sortPropertyGroups = function () {
        this.hasGroupLoading = this.detailObject.Groups.filter(function (x) { return x.GroupType == 'Loading'; }).length == 0 ? false : true;
        this.groups = this.detailObject.Groups.sort(function (a, b) {
            if (a.GroupOrder > b.GroupOrder) {
                return 1;
            }
            else if (a.GroupOrder < b.GroupOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    DetailComponent.prototype.sortDetailActions = function () {
        this.actions = this.detailObject.Actions.sort(function (a, b) {
            if (a.ActionOrder > b.ActionOrder) {
                return 1;
            }
            else if (a.ActionOrder < b.ActionOrder) {
                return -1;
            }
            else {
                return 0;
            }
        }).filter(function (x) { return !x.IsHidden; }).filter(function (x) { return !x.DisplayOnGroup; });
    };
    DetailComponent.prototype.sortPropertySections = function () {
        this.sections = this.detailObject.Sections.sort(function (a, b) {
            if (a.SectionOrder > b.SectionOrder) {
                return 1;
            }
            else if (a.SectionOrder < b.SectionOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    DetailComponent.prototype.getLookupList = function (property) {
        property.PropertyValueDisplayArray = [];
        if (property.PropertyValueArray) {
            property.PropertyValueArray.forEach(function (value) {
                if (property.PropertyValueSelection) {
                    if (property.PropertyValueSelection.length > 0) {
                        if (property.PropertyValueSelection.find(function (x) { return x.SelectionValue == value; })) {
                            property.PropertyValueDisplayArray.push(property.PropertyValueSelection.find(function (x) { return x.SelectionValue == value; }).SelectionDisplay);
                        }
                    }
                    else {
                        property.PropertyValueDisplayArray.push(value);
                    }
                }
            });
        }
    };
    DetailComponent.prototype.getHierarchy = function (property) {
        this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).treeControl = new NestedTreeControl(this.makeGetChildrenFunction());
        this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).treeDataSource = new MatTreeNestedDataSource();
        this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).treeDataSource.data = [];
        if (!property.PropertyValueSelection) {
            // this.detailService.getLookupList(this.componentId, property.PropertyName).subscribe(result=> {
            //   let lookupList:ValueSelection[] = JSON.parse(result);
            //   this.detailObject.Properties.find(x=> x.PropertyId == property.PropertyId).PropertyValueSelection = lookupList;
            //   this.constructHierarchy(property);       
            // });
        }
        else {
            this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).PropertyOriginalValueSelection = property.PropertyValueSelection;
            this.constructHierarchy(property, property.PropertyValueSelection);
        }
    };
    DetailComponent.prototype.showHierarchy = function (property, show) {
        var _this = this;
        if (this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; })) {
            var prop_1 = this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; });
            if (show && property.PropertyId != this.currentHierarchyId) {
                prop_1.PropertyLoadHierarchy = true;
                this.detailService.getLookupList(this.componentId, property.PropertyName).subscribe(function (result) {
                    var lookupList = JSON.parse(result);
                    _this.detailService.setTreeData({ name: property.PropertyName, data: lookupList });
                    lookupList = lookupList.slice(0, 100);
                    _this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }).PropertyValueSelection = lookupList;
                    _this.constructHierarchy(property, lookupList);
                    if (property.PropertyValueArray) {
                        _this.getLookupList(property);
                        //this.expandIfSelected(property);
                    }
                    prop_1.PropertyShowHierarchy = !prop_1.PropertyShowHierarchy;
                    _this.currentHierarchyId = property.PropertyId;
                    prop_1.PropertyLoadHierarchy = false;
                }, function (error) {
                    prop_1.PropertyLoadHierarchy = false;
                });
            }
            else {
                prop_1.PropertyShowHierarchy = !prop_1.PropertyShowHierarchy;
            }
        }
    };
    DetailComponent.prototype.expandIfSelected = function (prop) {
        prop.PropertyOriginalValueSelection.forEach(function (element) {
            if (element.GroupBy) {
            }
        });
    };
    DetailComponent.prototype.constructHierarchy = function (property, lookup) {
        var nodes = [];
        var treeNodes = [];
        if (lookup) {
            // property.PropertyValueSelection.forEach(element => {
            //   if (property.PropertyValueArray){
            //     if(property.PropertyValueArray.indexOf(element.SelectionValue) > -1){
            //       element.IsSelected = true;
            //     }
            //   }
            //   nodes.push({
            //     id: element.SelectionValue,
            //     title: element.SelectionDisplay,
            //     isSelected: element.IsSelected,
            //     parent: element.GroupBy
            //   });
            // });
            // property.PropertyValueSelection.forEach(element => {
            //   if (!element.GroupBy) {
            //     let tree = this.getNestedChildren(nodes, element.SelectionValue);
            //     treeNodes.push({
            //       id: element.SelectionValue,
            //       title: element.SelectionDisplay,
            //       isSelected: element.IsSelected,
            //       children: tree
            //     });
            //   }
            // });
            lookup.forEach(function (element) {
                if (property.PropertyValueArray) {
                    if (property.PropertyValueArray.indexOf(element.SelectionValue) > -1) {
                        element.IsSelected = true;
                    }
                }
                treeNodes.push({
                    id: element.SelectionValue,
                    title: element.SelectionDisplay,
                    isSelected: element.IsSelected,
                    hasChild: element.HasChild
                });
            });
            if (treeNodes.length > 0) {
                if (this.lookupArray.find(function (x) { return x.name == property.PropertyName; })) {
                    if (treeNodes.length != this.lookupArray.find(function (x) { return x.name == property.PropertyName; }).data.length) {
                        treeNodes[treeNodes.length - 1].hasLoadMore = true;
                    }
                }
            }
            this.getLookupList(property);
            this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).PropertyValueSelection = lookup;
            this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).treeControl.dataNodes = treeNodes;
            this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).treeDataSource = new MatTreeNestedDataSource();
            this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).treeDataSource.data = treeNodes;
        }
    };
    DetailComponent.prototype.reconstructHierarchy = function (property, node) {
        var _this = this;
        var nodes = [];
        var treeNodes = [];
        if (property.PropertyValueSelection) {
            property.PropertyValueSelection.forEach(function (element) {
                nodes.push({
                    id: element.SelectionValue,
                    title: element.SelectionDisplay,
                    isSelected: element.IsSelected,
                    parent: element.GroupBy,
                    hasChild: element.HasChild
                });
            });
            var isMultiHierarchy_1 = false;
            if (property.PropertyFormControlType.toUpperCase() == 'HIERARCHYMULTISELECT')
                isMultiHierarchy_1 = true;
            property.PropertyValueSelection.forEach(function (element) {
                if (!element.GroupBy) {
                    var tree = _this.getNestedChildren(nodes, element.SelectionValue, element.IsSelected, isMultiHierarchy_1);
                    treeNodes.push({
                        id: element.SelectionValue,
                        title: element.SelectionDisplay,
                        isSelected: element.IsSelected,
                        hasChild: element.HasChild,
                        children: tree
                    });
                }
            });
            if (treeNodes.length > 0) {
                if (this.lookupArray.find(function (x) { return x.name == property.PropertyName; })) {
                    if (treeNodes.length != this.lookupArray.find(function (x) { return x.name == property.PropertyName; }).data.length) {
                        treeNodes[treeNodes.length - 1].hasLoadMore = true;
                    }
                }
            }
            var prop = this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; });
            prop.treeControl.dataNodes = treeNodes;
            // mat-tree has some sort of memory leak issue when not instantiating a new MatTreeNestedDataSource which causes the app to become very slow
            prop.treeDataSource = new MatTreeNestedDataSource();
            prop.treeDataSource.data = treeNodes;
            //need to change the whole process of updating the object
        }
    };
    DetailComponent.prototype.onSearchHierarchy = function (keyword, property) {
        var _this = this;
        // if (keyword){
        this.detailService.searchDropdownList(this.componentId, property.PropertyName, keyword).subscribe(function (result) {
            var lookupList = JSON.parse(result);
            // this.detailService.setTreeData({name: property.PropertyName, data:lookupList});
            // lookupList = lookupList.slice(0, 100);
            if (lookupList) {
                _this.detailObject.Properties.find(function (x) { return x.PropertyId == property.PropertyId; }).PropertyValueSelection = lookupList;
                _this.constructLookupWithChild(property, lookupList);
                if (property.PropertyValueArray) {
                    _this.getLookupList(property);
                }
            }
        });
    };
    DetailComponent.prototype.constructLookupWithChild = function (property, lookup) {
        var _this = this;
        var nodes = [];
        var treeNodes = [];
        if (lookup) {
            lookup.forEach(function (element) {
                if (property.PropertyValueArray) {
                    if (property.PropertyValueArray.indexOf(element.SelectionValue) > -1) {
                        element.IsSelected = true;
                    }
                }
                nodes.push({
                    id: element.SelectionValue,
                    title: element.SelectionDisplay,
                    isSelected: element.IsSelected,
                    hasChild: element.HasChild,
                    parent: element.GroupBy
                });
            });
            lookup.forEach(function (element) {
                if (!element.GroupBy) {
                    var tree = _this.getNestedChildren(nodes, element.SelectionValue, element.IsSelected, property.PropertyFormControlType.toUpperCase() == 'HIERARCHYMULTISELECT');
                    treeNodes.push({
                        id: element.SelectionValue,
                        title: element.SelectionDisplay,
                        isSelected: element.IsSelected,
                        hasChild: element.HasChild,
                        children: tree
                    });
                }
            });
            this.getLookupList(property);
            this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).PropertyValueSelection = lookup;
            this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).treeControl.dataNodes = treeNodes;
            this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).treeDataSource = new MatTreeNestedDataSource();
            this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).treeDataSource.data = treeNodes;
        }
    };
    DetailComponent.prototype.onExpandNode = function (event, property) {
        var _this = this;
        // fix updating on expand node, should not go through the worst thing again
        var detailProp = this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; });
        if (detailProp) {
            var children = event.node.children;
            if (!children)
                children = [];
            if (event.isExpanded == true && children.length == 0) {
                this.detailService.getLookupList(this.componentId, detailProp.PropertyName, event.node.id).subscribe(function (result) {
                    var lookupList = JSON.parse(result);
                    lookupList = lookupList.map(function (x) {
                        x.GroupBy = event.node.id;
                        return x;
                    });
                    var list = detailProp.PropertyValueSelection;
                    lookupList.forEach(function (element) {
                        if (detailProp.PropertyValueSelection.findIndex(function (x) { return x.SelectionValue == element.SelectionValue; }) < 0) {
                            if (property.PropertyValueArray) {
                                if (property.PropertyValueArray.findIndex(function (x) { return x == element.SelectionValue; }) > -1) {
                                    element.IsSelected = true;
                                }
                            }
                            list.push(element);
                        }
                    });
                    // list = list.concat(lookupList);
                    // update hierarchy
                    detailProp.PropertyValueSelection = list;
                    _this.detailService.setTreeData({ name: property.PropertyName, data: property.PropertyValueSelection });
                    // this.reconstructHierarchy(detailProp, event.node);
                    _this.updateChildren(detailProp, event.node, lookupList);
                }, function (error) {
                    // prop.PropertyLoadHierarchy = false;
                });
            }
        }
    };
    DetailComponent.prototype.updateChildren = function (property, node, newDatanodes) {
        var prop = this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; });
        // for (var i = 0;i < prop.treeControl.dataNodes.length; i++){
        //   _node = this.searchInTree(prop.treeControl.dataNodes[i], node.id);
        //   if (_node) break;
        // }
        // console.log(_node);
        // if (_node){
        var isMultiHierarchy = false;
        if (property.PropertyFormControlType.toUpperCase() == 'HIERARCHYMULTISELECT')
            isMultiHierarchy = true;
        var nodes = [];
        var valueArray = prop.PropertyValueArray;
        if (!valueArray)
            valueArray = [];
        newDatanodes.forEach(function (element) {
            var selected = false;
            if (valueArray.length > 0) {
                if (valueArray.indexOf(element.SelectionValue) > -1) {
                    selected = true;
                }
                else {
                    if (isMultiHierarchy) {
                        selected = node.isSelected;
                    }
                }
            }
            nodes.push({
                id: element.SelectionValue,
                title: element.SelectionDisplay,
                isSelected: selected,
                parent: element.GroupBy,
                hasChild: element.HasChild
            });
        });
        var treeNodes = [].concat(prop.treeControl.dataNodes);
        var _node = null;
        // var _foundNode = null;
        for (var i = 0; i < treeNodes.length; i++) {
            _node = this.searchInTree(treeNodes[i], node.id);
            if (_node) {
                _node.isLoading = false;
                _node.children = nodes;
                break;
            }
        }
        if (_node) {
            // treeNodes.push(_node);
            prop.treeControl.dataNodes = treeNodes;
            // cdk tree that mat tree is based on has a bug causing children to not be rendered in the UI without first setting the data to null
            prop.treeDataSource.data = null;
            // mat-tree has some sort of memory leak issue when not instantiating a new MatTreeNestedDataSource which causes the app to become very slow
            prop.treeDataSource = new MatTreeNestedDataSource();
            prop.treeDataSource.data = treeNodes;
        }
        // }
    };
    DetailComponent.prototype.searchInTree = function (element, id) {
        if (element.id == id) {
            return element;
        }
        else if (element.children != null) {
            var i;
            var result = null;
            for (i = 0; result == null && i < element.children.length; i++) {
                result = this.searchInTree(element.children[i], id);
            }
            return result;
        }
        return null;
    };
    DetailComponent.prototype.onCheckedItem = function ($event, property) {
        var findProp = this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; });
        var selectedProp = findProp.PropertyValueSelection.find(function (item) { return item.SelectionValue == $event.id; });
        if (selectedProp)
            selectedProp.IsSelected = !selectedProp.IsSelected;
        if (findProp.PropertyFormControlType.toUpperCase() == "HIERARCHYMULTISELECT") {
            if (findProp.PropertyValueArray) {
                var addToArray = false;
                if (findProp.PropertyValueArray.filter(function (x) { return x == $event.id; }).length == 0) {
                    findProp.PropertyValueArray.push($event.id);
                    findProp.PropertyValueDisplayArray.push($event.title);
                    addToArray = true;
                }
                else {
                    findProp.PropertyValueArray.splice(findProp.PropertyValueArray.findIndex(function (x) { return x == $event.id; }), 1);
                    addToArray = false;
                }
                this.pushValueSelection(property);
                // add checking to remove child if found parent
                // do for both adding and removing items events, adding or removing items will remove all of its child from the parent 
                this.findChild(findProp, $event.id);
            }
            else {
                findProp.PropertyValueArray = [];
                findProp.PropertyValueDisplayArray = [];
                findProp.PropertyValueArray.push($event.id);
                findProp.PropertyValueDisplayArray.push($event.title);
            }
        }
        else if (findProp.PropertyFormControlType.toUpperCase() == "HIERARCHYSINGLESELECT") {
            if (findProp.PropertyValueArray) {
                if (findProp.PropertyValueArray.findIndex(function (x) { return x == $event.id; }) > -1) {
                    findProp.PropertyValueArray = [];
                    findProp.PropertyValueDisplayArray = [];
                }
                else {
                    findProp.PropertyValueArray = [];
                    findProp.PropertyValueDisplayArray = [];
                    findProp.PropertyValueArray.push($event.id);
                    findProp.PropertyValueDisplayArray.push($event.title);
                }
            }
            else {
                findProp.PropertyValueArray = [];
                findProp.PropertyValueDisplayArray = [];
                findProp.PropertyValueArray.push($event.id);
                findProp.PropertyValueDisplayArray.push($event.title);
            }
        }
        var array = Object.assign({}, this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; })); //just to trigger angular !
        this.propertyUpdate = array;
    };
    DetailComponent.prototype.pushValueSelection = function (property) {
        var prop = this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; });
        if (prop) {
            if (prop.PropertyOriginalValueSelection) {
                prop.PropertyOriginalValueSelection.forEach(function (item) {
                    if (prop.PropertyValueSelection.filter(function (x) { return x.SelectionValue == item.SelectionValue; }).length == 0) {
                        prop.PropertyValueSelection.push(item);
                    }
                    // else{
                    //   prop.PropertyValueSelection.splice(prop.PropertyValueSelection.findIndex(x => x.SelectionValue == item.SelectionValue), 1);
                    // }
                });
            }
        }
    };
    DetailComponent.prototype.findChild = function (property, id) {
        var _this = this;
        // if selected values dont have the item, find if got child
        if (property.PropertyValueArray) {
            var selectedItems = property.PropertyValueSelection.filter(function (x) { return x.GroupBy.toLowerCase() == id.toLowerCase(); });
            selectedItems.forEach(function (element) {
                _this.removeChild(property, element.SelectionValue);
            });
        }
        // if (property.PropertyOriginalValueSelection.filter(x => x.GroupBy == id).length > 0){
        //   // if got child
        //   let selectedItems = property.PropertyOriginalValueSelection.filter(x => x.GroupBy == id);
        //   selectedItems.forEach(item => {
        //     this.removeInChild(property, item.SelectionValue);
        //   });
        // }
    };
    DetailComponent.prototype.removeChild = function (property, id) {
        var _this = this;
        if (property.PropertyValueArray.filter(function (x) { return x == id; }).length > 0) {
            // if selected values already have the item
            this.detailProperties.find(function (x) { return x.PropertyId == property.PropertyId; }).PropertyValueArray.splice(property.PropertyValueArray.findIndex(function (x) { return x == id; }), 1);
        }
        else {
            // if selected values dont have the item, find if got child
            if (property.PropertyValueArray) {
                var selectedItems = property.PropertyValueSelection.filter(function (x) { return x.GroupBy.toLowerCase() == id.toLowerCase(); });
                selectedItems.forEach(function (element) {
                    _this.removeChild(property, element.SelectionValue);
                });
            }
        }
    };
    DetailComponent.prototype.onContextMenu = function ($event, item) {
        if ($event.button == 0) {
            this.contextMenuService.show.next({
                contextMenu: this.basicMenu,
                event: $event,
                item: item,
            });
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    DetailComponent.prototype.getNestedChildren = function (arr, parentId, isSelected, isMulti) {
        if (isMulti === void 0) { isMulti = false; }
        var out = [];
        var _loop_1 = function (i) {
            if (arr[i].parent.toLowerCase() == parentId.toLowerCase()) {
                var children = null;
                if (isMulti) {
                    arr[i].isSelected = isSelected ? isSelected : arr[i].isSelected;
                    arr[i].isDisabled = isSelected ? isSelected : arr[i].isSelected;
                    children = this_1.getNestedChildren(arr, arr[i].id, isSelected ? isSelected : arr[i].isSelected, isMulti);
                }
                else {
                    children = this_1.getNestedChildren(arr, arr[i].id, arr[i].isSelected, isMulti);
                }
                if (children.length) {
                    if (isMulti) {
                        children.forEach(function (element) {
                            if (arr[i].isSelected) {
                                element.isSelected = arr[i].isSelected;
                                element.isDisabled = arr[i].isSelected;
                            }
                            else {
                                element.isSelected = element.isSelected;
                                element.isDisabled = false;
                            }
                        });
                    }
                    arr[i].children = children;
                }
                out.push(arr[i]);
            }
        };
        var this_1 = this;
        for (var i in arr) {
            _loop_1(i);
        }
        return out;
    };
    // getNestedChildren(arr, parentId, isSelected, isMulti: boolean = false) {
    //   let out = []
    //   for(let i in arr) {
    //     if(arr[i].parent == parentId) {
    //       let children = this.getNestedChildren(arr, arr[i].id, arr[i].isSelected, isMulti);
    //       if(children.length) {
    //         if (isMulti){
    //           children.forEach(element => {
    //             element.isSelected = arr[i].isSelected;
    //             element.isDisabled = arr[i].isSelected;
    //           });
    //         }
    //         arr[i].children = children;
    //       }
    //       out.push(arr[i])
    //     }
    //   }
    //   return out
    // }
    DetailComponent.prototype.constructCombinationProperty = function (element) {
        var split = element.PropertyDisplayFormat.split('|');
        var initialColumn = split[0].substring(0, split[0].indexOf('%'));
        var initialColumnWidth = split[0].substring(split[0].indexOf('%') + 1) + "%";
        var secColumn = "";
        var secColumnWidth = "";
        if (split.length > 1) {
            secColumn = split[1].substring(0, split[1].indexOf('%'));
            secColumnWidth = split[1].substring(split[1].indexOf('%') + 1) + "%";
        }
        var allProperties = [];
        var initialProp = this.hiddenProperties.find(function (x) { return x.PropertyName == initialColumn; });
        var secProp = this.hiddenProperties.find(function (x) { return x.PropertyName == secColumn; });
        if (initialProp) {
            allProperties.push(initialProp);
        }
        if (secProp) {
            allProperties.push(secProp);
        }
        var width = [{ initialColumnWidth: initialColumnWidth, secColumnWidth: secColumnWidth }];
        this.combinationProperty.push({
            combinationId: element.PropertyId,
            properties: allProperties,
            columnWidth: width,
            IsInputLabel: false
        });
    };
    DetailComponent.prototype.constructSubForm = function (subForm, propertyGroup) {
        var _this = this;
        this.subForms[propertyGroup.GroupName] = subForm.form.status;
        subForm.actions.forEach(function (action) {
            _this.subForms[action.ActionCommand] = action.TriggersValidation;
        });
    };
    DetailComponent.prototype.sortProperties = function () {
        this.detailProperties = this.detailProperties.sort(function (a, b) {
            if (a.PropertyOrder > b.PropertyOrder) {
                return 1;
            }
            else if (a.PropertyOrder < b.PropertyOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    DetailComponent.prototype.sortPropertiesByGroup = function () {
        var properties = this.detailObject.Properties.filter(function (x) { return !x.PropertyIsHidden; }).sort(function (a, b) {
            if (a.PropertyOrder > b.PropertyOrder) {
                return 1;
            }
            else if (a.PropertyOrder < b.PropertyOrder) {
                return -1;
            }
            else {
                return 0;
            }
        });
        var propertiesByGroup = [];
        this.groups.forEach(function (group) {
            propertiesByGroup = propertiesByGroup.concat(properties.filter(function (x) { return x.PropertyGroupId == group.GroupId; }));
        });
        return propertiesByGroup;
    };
    DetailComponent.prototype.checkIfHasUpdate = function () {
        var _this = this;
        if (this.componentId && !this.noLoading) {
            this.detailService.checkIfDetailHasUpdate(this.componentId).subscribe(function (result) {
                if (result == "1") {
                    _this.noLoading = true;
                    _this.getDetailCard();
                }
            }, function (error) {
                _this.sub.unsubscribe();
            });
        }
    };
    DetailComponent.prototype.onGroupOpened = function (group) {
        var _this = this;
        var expand = false;
        if (group.InitialLoad) {
            this.groups.find(function (x) { return x.GroupId == group.GroupId; }).InitialLoad = false;
        }
        else {
            expand = group.IsExpanded;
            this.groups.find(function (x) { return x.GroupId == group.GroupId; }).IsExpanded = true;
        }
        if (this.hiddenPropertyFocus) {
            setTimeout(function () {
                _this.detailService.setPropertyFocus(_this.hiddenPropertyFocus.PropertyId);
                _this.hiddenPropertyFocus = null;
            }, 100);
        }
        return expand;
    };
    DetailComponent.prototype.updateActionsDisplay = function () {
        var availableSpace;
        if ((this.detailObject.DocTitle || this.detailObject.DocSubtitle) && !this.isPopupDetail) {
            if ((this.titleElem.nativeElement.offsetWidth / this.detailHeader.nativeElement.offsetWidth * 100) > 70) {
                availableSpace = (0.3 * this.detailHeader.nativeElement.offsetWidth) + 50;
            }
            else {
                availableSpace = this.detailHeader.nativeElement.offsetWidth - this.titleElem.nativeElement.offsetWidth - 50;
            }
        }
        else {
            availableSpace = this.detailHeader.nativeElement.offsetWidth;
        }
        if (this.subActionContainer) {
            var actionsWidth = this.subActionContainer.nativeElement.offsetWidth;
            actionsWidth = actionsWidth + 44;
            if (actionsWidth > availableSpace) {
                // move the children to hidden actions
                if (this.hiddenList.length > 0) {
                    this.render.insertBefore(this.hiddenActions.nativeElement, this.subActionContainer.nativeElement.children[this.subActionContainer.nativeElement.children.length - 1], this.hiddenActions.nativeElement.children[0]);
                }
                else {
                    this.render.appendChild(this.hiddenActions.nativeElement, this.subActionContainer.nativeElement.children[this.subActionContainer.nativeElement.children.length - 1]);
                }
                // record width
                this.hiddenList.push(actionsWidth);
                // show the btn
                this.showBtnMore = true;
            }
            else {
                this.moveItemToVisible(availableSpace);
                // Hide the dropdown btn if hidden list is empty
                if (this.hiddenList.length < 1) {
                    this.showBtnMore = false;
                    this.showHidden = false;
                }
            }
            // Recur if the visible list is still overflowing the nav
            if (actionsWidth > availableSpace) {
                this.updateActionsDisplay();
            }
        }
    };
    DetailComponent.prototype.moveItemToVisible = function (availableSpace) {
        if (availableSpace > this.hiddenList[this.hiddenList.length - 1]) {
            // Move the item to the visible list
            this.render.appendChild(this.subActionContainer.nativeElement, this.hiddenActions.nativeElement.children[0]);
            this.hiddenList.pop();
            //recur if still have item that can move to visible list
            this.moveItemToVisible(availableSpace);
        }
    };
    DetailComponent.prototype.onResized = function (event) {
        if (this.actionsReady && this.displayDetail)
            this.updateActionsDisplay();
    };
    DetailComponent.prototype.afterInit = function () {
        this.actionsReady = true;
        if (this.displayDetail) {
            this.updateActionsDisplay();
        }
    };
    DetailComponent.prototype.onFormInit = function () {
        var _this = this;
        if (this.detailForm) {
            var obj = { form: this.detailForm, actions: this.detailObject.Actions };
            this.subForm.emit(obj);
            this.detailForm.statusChanges.subscribe(function (result) {
                var obj = { form: _this.detailForm, actions: _this.detailObject.Actions };
                _this.subForm.emit(obj);
            });
        }
    };
    DetailComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.detailForm) {
            this.detailForm.statusChanges.subscribe(function (result) {
                var obj = { form: _this.detailForm, actions: _this.actions };
                _this.subForm.emit(obj);
            });
        }
    };
    DetailComponent.prototype.ngOnChanges = function (changes) {
        //this.isBusy = true;
        //this.getDetailCard();
    };
    DetailComponent.prototype.onModalScrollDown = function (event) {
        this.detailScrollPoint = event.currentScrollPosition;
        if (this.isPreview) {
            this.next.next();
        }
    };
    DetailComponent.prototype.groupInit = function (group) {
        if (this.previewLoading && this.isPreview) {
            if (this.isScrolledIntoView(this.previewLoading.nativeElement)) {
                this.getPreviewNextSection(null);
            }
        }
    };
    // getLoadingPosition(el){
    //   console.log(el.offsetParent);
    //   return (el.offsetParent === null);
    // }
    DetailComponent.prototype.isScrolledIntoView = function (el) {
        var rect = el.getBoundingClientRect();
        var elemTop = rect.top;
        var elemBottom = rect.bottom;
        // Only completely visible elements return true:
        var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
        // Partially visible elements return true:
        //isVisible = elemTop < window.innerHeight && elemBottom >= 0;
        return isVisible;
    };
    DetailComponent.prototype.getPreviewNextSection = function (event) {
        var _this = this;
        this.loadingPreview.next(true);
        this.loadingNextPreview = true;
        this.detailService.getPreviewNextSection(this.componentId, "2").subscribe(function (result) {
            _this.loadingPreview.next(false);
            _this.loadingNextPreview = false;
            if (result) {
                //means there's new group
                var newDetail = JSON.parse(result);
                var properties = newDetail.Properties.filter(function (x) { return x.PropertyOrder != 0; }).filter(function (x) { return !x.PropertyIsHidden; });
                _this.hiddenProperties = _this.hiddenProperties.concat(newDetail.Properties.filter(function (x) { return x.PropertyOrder == 0; }));
                _this.detailObject.Groups = [].concat(_this.detailObject.Groups);
                _this.detailObject.Properties = [].concat(_this.detailObject.Properties);
                _this.tempDetailProperties = [];
                properties.forEach(function (element) {
                    if (_this.detailProperties.find(function (x) { return x.PropertyId == element.PropertyId; }) == null) {
                        _this.tempDetailProperties.push(element);
                    }
                });
                _this.formatProperties(true);
                _this.detailProperties = _this.detailProperties.concat(_this.tempDetailProperties);
                _this.sortProperties();
                newDetail.Groups.forEach(function (element) {
                    if (!element.GroupActions)
                        element.GroupActions = [];
                    if (_this.groups.find(function (x) { return x.GroupId == element.GroupId; }) == null) {
                        // this.groups.push({...element});
                        _this.groups.push(Object.assign({}, element));
                    }
                });
                // this.sortPropertyGroups();
            }
        }, function (error) {
            _this.loadingPreview.next(false);
            _this.loadingNextPreview = false;
            _this.lastPreview = true;
        });
    };
    DetailComponent.prototype.openInNewWindow = function () {
        console.log(this.router.url);
        window.open(this.router.url, "_blank", "width=600,height=500");
    };
    DetailComponent.prototype.pin = function () {
        this.floatingPanelService.pushNewTab(this.componentId, this.detailObject.DocTitle);
    };
    DetailComponent.prototype.removePin = function (id) {
        this.floatingPanelService.removeTab(this.componentId);
    };
    return DetailComponent;
}());
export { DetailComponent };
